export default __webpack_public_path__ + "26f69c7a397aa73902453a2e0610ad38.png";